import { PaymentMode, ChequeStatus } from './enums/PaymentMode.enum';

export enum OrderPaymentStatus {
  PENDING_APPROVAL = 1,
  APPROVED = 2,
  REJECTED = 3,
  PAID = 4,
}

export interface OrderPayment {
  id: string;
  orderId: string;
  paymentDate: string;
  paidAmount: number;
  paymentMode: PaymentMode | string;
  receivedBy?: string;
  status: OrderPaymentStatus | string;
  approvedBy?: string | null;
  approvedDate?: string | null;
  notes?: string | null;
  rejectionNotes?: string | null;
  chequeNumber?: string | null;
  chequeDate?: string | null;
  chequeStatus?: ChequeStatus | null;
  chequeRealizedDate?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  transactionReference?: string | null;
  chequeDetails?: string;
  bankAccount?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PaginatedOrderPaymentResponse {
  data: OrderPayment[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}

export interface OrderPaymentFormValues {
  id: string;
  orderId: string;
  paymentDate: string;
  amount: string;
  paymentMode: PaymentMode | '';
  status: OrderPaymentStatus;
  chequeNumber: string;
  chequeDate: string;
  chequeStatus: string;
  bankAccountId: string;
  transactionReference: string;
  notes: string;
}

export interface OrderPaymentPayload {
  id?: string;
  orderId?: string;
  paymentDate: string;
  amount: number;
  paymentMode: PaymentMode | string;
  chequeNumber?: string;
  chequeDate?: string;
  chequeStatus?: string;
  bankAccountId?: string;
  paymentRefNo?: string;
  notes?: string;
}

export interface OrderPaymentGridProps {
  orderId: string;
  state: boolean;
  banks: any[];
  onBanksFetch?: () => void;
  onPaymentModeChange?: (paymentMode: PaymentMode | '') => void;
}

export interface OrderPaymentActionMenuProps {
  rowId: string | number;
  id: string;
  orderId: string;
  status: OrderPaymentStatus | string;
  paymentMode: PaymentMode | string;
  banks: any[];
  fetchPayments: () => void;
  deletePayment: (id: string) => void;
  onBanksFetch?: () => void;
  onPaymentModeChange?: (paymentMode: PaymentMode | '') => void;
}

export interface ViewOrderPaymentDialogProps {
  open: boolean;
  onClose: () => void;
  payment: OrderPayment | null;
}

export interface OrderDetailsResponse {
  orderNumber?: string;
  totalPaidAmount?: number;
  grandTotal?: number;
}
